module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 107.cd1a0280.png";